import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenDropdown',
  props: {
  defaultToken: Object,
  tokenList: Array,
  onSelect: Function,
},
  setup(__props) {

const props = __props



const { state } = useStore();
const selected = ref({});

onMounted(() => {
  selected.value = props.defaultToken ? props.defaultToken : { address: 'usd', symbol: 'USD' };
});

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    modelValue: selected.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
    options: __props.tokenList,
    "option-label": "symbol",
    class: "dropdown-button",
    "panel-class": "dropdown-list mt-s1",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (__props.onSelect(selected.value)))
  }, {
    value: _withCtx((slotProps) => [
      _createVNode(TokenIcon, {
        "icon-src": slotProps.value.tokenIconUrl,
        symbol: slotProps.value.symbol,
        size: _unref(state).layout.isMobile ? '20' : '24',
        full: !_unref(state).layout.isMobile
      }, null, 8, ["icon-src", "symbol", "size", "full"])
    ]),
    option: _withCtx((slotProps) => [
      _createVNode(TokenIcon, {
        "icon-src": slotProps.option.tokenIconUrl,
        symbol: slotProps.option.symbol,
        size: _unref(state).layout.isMobile ? '20' : '24',
        full: ""
      }, null, 8, ["icon-src", "symbol", "size"])
    ]),
    _: 1
  }, 8, ["modelValue", "options"]))
}
}

})